var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkyIsotype = function SvgSkyIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 31 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__a)",
    d: "M2.886 6.596a14.5 14.5 0 0 1 1.54-1.706l.187.098L15.01 14.88l.099.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__b)",
    d: "M4.425 4.89C6.681 2.755 9.594 1.351 12.745.88l.105.272 2.259 13.66V15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__c)",
    d: "M21.97 2.262q1.058.51 2.02 1.171l-.027.223-8.8 11.302-.054.042z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__d)",
    d: "M30.217 15c0 1.5-.25 2.991-.74 4.418l-.357.055-13.9-4.42-.111-.053z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__e)",
    d: "M29.478 19.418a14 14 0 0 1-2.146 3.985l-.344-.055L15.18 15.07 15.11 15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__f)",
    d: "M19.778 28.598a15.9 15.9 0 0 1-7.033.523l-.094-.274 2.39-13.604.068-.243z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__g)",
    d: "M12.745 29.121a16 16 0 0 1-2.305-.523l-.042-.331 4.625-13.118.086-.149z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__h)",
    d: "M10.44 28.598a15.5 15.5 0 0 1-4.212-2.031v-.26l8.726-11.161.155-.146z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__i)",
    d: "M1.647 21.49A13.7 13.7 0 0 1 0 15l.193-.068H14.62l.489.068z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__j)",
    d: "M12.744.879a15.9 15.9 0 0 1 7.034.524L15.108 15z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__k)",
    d: "M23.99 3.433c2.58 1.775 4.502 4.277 5.488 7.148L15.108 15z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__l)",
    d: "M6.228 26.567a14.7 14.7 0 0 1-3.342-3.163L15.109 15z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__m)",
    d: "M0 15c0-1.5.25-2.991.74-4.418L15.108 15z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sky-isotype_svg__n)",
    d: "M27.332 23.403a14.7 14.7 0 0 1-3.342 3.163L15.11 15z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.50506 -9.40037 9.31122 -11.39595 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A273FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-99.496 13.904 1.104)scale(14.6613 15.4494)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DDFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.482 0 0 -14.6505 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC044"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -14.6255 15.4558 0 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A273FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAF2E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(34.5 -16.6 31.829)scale(15.1309 14.8544)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DDFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 14.6376 -15.4684 0 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5EDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 14.6678 -15.5004 0 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DDFB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(115.375 2.81 12.278)scale(15.8239 16.401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C99BED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-20.125 0 0 -19.0441 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D28FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A7F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -14.6257 15.4558 0 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A273FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9FAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAF2E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 14.6376 -15.4684 0 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5EDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.50506 -9.40037 9.31122 -11.39595 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A273FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-15.482 0 0 -14.6505 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC044"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sky-isotype_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.50506 -9.40037 9.31122 -11.39595 15.109 15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A273FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4331E9"
  })))));
};
export default SvgSkyIsotype;